import { Box, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const passwordRules = {
  minLength: (pw: string) => pw.length >= 8,
  hasUpper: (pw: string) => /[A-Z]/.test(pw),
  hasLower: (pw: string) => /[a-z]/.test(pw),
  hasNumber: (pw: string) => /\d/.test(pw),
  hasSymbol: (pw: string) => /[^A-Za-z0-9]/.test(pw),
  noForbiddenWords: (pw: string) => !/(idecon|ehesapp)/i.test(pw),
};

const RuleItem = ({ ok, text }: { ok: boolean; text: string }) => (
  <Box display="flex" alignItems="center" gap={1}>
    {ok ? <CheckCircleOutlineIcon color="success" fontSize="small" /> : <CancelIcon color="error" fontSize="small" />}
    <Typography variant="body2">{text}</Typography>
  </Box>
);
export default RuleItem;
